import { Icon, Text } from "@ilc-technology/luik";
import React from "react";
import { Link } from "react-router-dom";
import { Telephone } from "../../contexts/SessionContext/SessionContext";

interface Logo {
  filename: string;
}

interface TopBarProps {
  logo: Logo;
  telephone?: Telephone;
  alt?: string;
}

const TopBar: React.FC<TopBarProps> = ({ logo, telephone, alt = "Centered" }) => {
  //In central api general number is the one that's to show on screen: 06 1 327 8050
  const generalNumber = telephone?.generalNumber;

  // formatted number is the one that can be called and looks like this: 0613278050
  const formattedNumber = telephone?.generalNumberFormattedForMobile;

  return (
    <>
      <div
        className="a-top-bar-height relative flex w-full items-center justify-center border-b border-ink-black-border"
        data-testid="top-bar"
      >
        <Link to="/">
          <img src={logo.filename} className="h-8" alt={alt} data-testid="top-bar-logo" />
        </Link>
        {formattedNumber && (
          <a
            className="absolute right-0 mr-4 flex items-center gap-2 hover:cursor-pointer hover:underline md:flex"
            href={`tel:${formattedNumber}`}
          >
            <Text variant="label-md" className="hidden items-center lg:flex" data-testid="top-bar-phone">
              {generalNumber ?? formattedNumber}
            </Text>
            <Icon size="sm" iconName="phone" />
          </a>
        )}
      </div>
    </>
  );
};

export default TopBar;
